import { Loader, CentralCardLayoutWrapper } from '@percent/cause-dashboard/common/components'

import styles from './AgentVerify.module.scss'
import { AgentVerifyProps } from './AgentVerify.types'
import { useEffect } from 'react'
import { AnimatedContainer } from '@percent/lemonade'
import { useTranslation } from 'react-i18next'
import { ReactComponent as SuccessResultBadge } from '@percent/cause-dashboard/common/assets/images/success-result-badge.svg'
import { AgentVerifyErrorView } from './agentVerifyErrorView/AgentVerifyErrorView'

export const HELP_LINK_TEXT = 'help.goodstack.org'

export function AgentVerify({ isLoading, data, error }: AgentVerifyProps) {
  const { t: loco, i18n } = useTranslation('causeDashboardLoco')

  useEffect(() => {
    if (data?.language) {
      i18n.changeLanguage(data?.language)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  if (error) return <AgentVerifyErrorView error={error} />
  return (
    <CentralCardLayoutWrapper hideLocalePicker>
      {isLoading && <Loader isAuthLoader />}

      {!isLoading && (
        <div className={styles.contentWrapper}>
          <div className={styles.resultBadgeWrapper} data-testid="success-result-badge">
            <AnimatedContainer>
              <SuccessResultBadge />
            </AnimatedContainer>
          </div>
          <h3>
            {loco(
              `webscreen.ask_nonprofit_to_confirm_agent.${
                data?.associationAlreadyRecorded ? 'headingReplySubmitted' : 'headingThanks'
              }`
            )}
          </h3>
        </div>
      )}
    </CentralCardLayoutWrapper>
  )
}
